export enum CheckoutStepNameEnum {
    CART = 'cart',
    LOGIN = 'login',
    SIGNUP = 'signup',
    SHIPPING = 'shipping',
    PAYMENT = 'payment'
}

export type CheckoutSteps = {
    [key: string]: number
}

export const checkoutSteps: CheckoutSteps = {
    cart: 1,
    login: 2,
    signup: 2,
    shipping: 3,
    payment: 4
}
